import React from "react";
import SkillSection from "./SkillSection";
import { SkillSection as SkillSectionType } from "../data/portfolio";

interface MainSectionProps {
  skillSection: SkillSectionType;
}

const MainSection: React.FC<MainSectionProps> = ({ skillSection }) => {
  return (
    <section className="flex flex-col p-6 border border-current rounded-lg h-full">
      <div className="flex-none h-[80px] flex items-center justify-center">
        <h2 className="text-3xl text-center">{skillSection.title}</h2>
      </div>
      
      <div className="flex flex-col gap-6 flex-1">
        {skillSection.skillGroups.map((group, index) => (
          <SkillSection key={index} skillGroup={group} />
        ))}
      </div>
    </section>
  );
};

export default MainSection;
